export default "__VITE_ASSET__DSyihwQ9__"